export default __webpack_public_path__ + "static/img_1_2-1a7f860503c0569204ab09d5a025a838.jpg";